function updateDiscount() {
	let originalTotalPrice = 0;
	let totalDiscount = 0;
	let cartCurrency = '';

	const cartTotalElement = [...document.querySelectorAll(".totals__total-value")]
	.find(el => el.hasAttribute("cart-total"));

	if (!cartTotalElement) return;
	const cartTotal = parseFloat(cartTotalElement.getAttribute("cart-total"));

	if (!cartTotal) return;

	document.querySelectorAll(".cart-item")?.forEach((item) => {
		const compareAtPrice = parseFloat(item.dataset.productPrice) || 0;
		const quantity = parseInt(item.dataset.quantity) || 1;
		cartCurrency = item.dataset.currency;
		originalTotalPrice += compareAtPrice * quantity;
	});

	totalDiscount = originalTotalPrice - cartTotal;

	let discountContainer = document.getElementById("discount-message-container");
	let mobileDiscountContainer = document.getElementById("mobile-discount-message-container");

	// If containers don't exist, don't proceed
	if (!discountContainer && !mobileDiscountContainer) return;

	if (totalDiscount > 0) {
		const discountHTML = `
		<div class="discount-banner-container">
			<p id="discount-message">You saved ${cartCurrency}${formatMoneyNumber(totalDiscount)}</p>
		</div>
		`;

		if (discountContainer) {
			discountContainer.innerHTML = discountHTML;
		}

		if (mobileDiscountContainer) {
			mobileDiscountContainer.innerHTML = discountHTML;
			// Force a style recalculation
			mobileDiscountContainer.offsetHeight;
		}
	} else {
		if (discountContainer) {
			discountContainer.style.display = "none";
			discountContainer.innerHTML = "";
		}
		if (mobileDiscountContainer) {
			mobileDiscountContainer.style.display = "none";
			mobileDiscountContainer.innerHTML = "";
		}
	}
}

function formatMoneyNumber(amount) {
	return (amount / 100).toLocaleString("en-US", {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2
	});
}

function observeCartChanges() {
	const cartTotalElement = [...document.querySelectorAll(".totals__total-value")]
		.find(el => el.hasAttribute("cart-total"));
	if (!cartTotalElement) return;
	const observer = new MutationObserver(() => updateDiscount());
	observer.observe(cartTotalElement, {
		childList: true,
		subtree: true,
		characterData: true,
		attributes: true,
		attributeFilter: ['cart-total']
	});
}

document.addEventListener("DOMContentLoaded", () => {
	// Add a delay to ensure all elements are loaded
	setTimeout(() => {
		observeCartChanges();
		updateDiscount();
	}, 500);

	// Subscribe to cart update events to trigger discount updates
	if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
		subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
			// Add a longer delay to ensure DOM replacement is complete before recalculating discounts
			setTimeout(() => {
				updateDiscount();
			}, 600);
		});
	}
});
